import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import * as IdKey from "short-uuid";
import { Button, Grid, Tooltip,} from "@material-ui/core";
import VisibilityIcon from "@material-ui/icons/Visibility";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { withStyles } from "@material-ui/core/styles";
import ModalConfirmBase from "../../utils/form/modalConfirmBase";
import {
  permissionsApprove,
  permissionsCancel,
  permissionsPreApprove,
  permissionsReject,
} from "../../actions/permissions-actions";
import ModalConfirmBaseComment from "../../utils/form/modalConfirmBaseComment";
import utils from "../../utils/utils";
import { permissionsConstans } from "../../constansPermissions";
import moment from "moment";
import {
  NORMALUSER, APPROVER, RHMANAGE
} from "../../constants";

const useStyles = makeStyles((theme) => ({
  MuiIconButtonEdgeEnd: {
    order: "-1",
  },
  root: {
    width: "100%",
    marginTop: "10px",
    marginLeft: "10px",
  },
  rootGrid: {
    flexGrow: 1,
  },
  heading: {
    fontSize: theme.typography.pxToRem(12),
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(12),
    color: theme.palette.text.secondary,
  },
  icon: {
    verticalAlign: "bottom",
    height: 20,
    width: 20,
  },
  iconEvent: {
    color: "#666666",
    cursor: "pointer",
    height: 18,
    width: 18,
  },
  details: {
    alignItems: "center",
    backgroundColor: "#EEFBFF",
  },
  column: {
    flexBasis: "39.6%",
  },
  columnEvent: {
    paddingLeft: "20px",
    flexBasis: "33.33%",
  },
  helper: {
    borderLeft: `2px solid ${theme.palette.divider}`,
    padding: theme.spacing(1, 2),
  },
  link: {
    color: theme.palette.primary.main,
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  buttonAnular: {
    color: "#ffffff",
    background: "#7EBDCE",
    width: "max-content",
    marginRight: 10,
    position: "relative",
    height: "fit-content",
    "&:hover": { color: "white", background: "#099F9F" },
  },
  observation: {
    backgroundColor: "#FFFFFF",
    boxSizing: "border-box",
    borderRadius: "8px",
    height: 95,
    fontSize: "14px",
    [`& fieldset`]: {
      borderRadius: 8,
      fontSize: 14,
    },
  },
}));

const DetailedAccordion = (props) => {
  const { headers, data, contractTypes, type} = props;
  const classes = useStyles();
  const id = IdKey.generate();
  const [userId, setUserId] = useState("");
  const [message, setMessage] = useState({
    description: "",
    textButtonSubmit: "",
    handleClick: () => {},
    handleClickOut: () => {},
    oneButtons: false,
    type: "",
    open: false,
  });
  const[permissions,setPermissions]=useState([]);

  const [confirm, setConfirm] = useState({
    open: false,
    question: "",
    handleClickOut: () => {},
    handleClick: () => {},
    buttonOneText: "",
    type: "",
    isCommentRequired: false,
    isPermissions: false,
    isPermissionApprove:false
  });

  useEffect(() => {
    const responsePermManage = utils.validationPermissions("PERM_MANAGE");
    const responsePerm = utils.validationPermissions("PERM");
    const permissionList = responsePermManage?.functionalities?.concat(responsePerm?.functionalities)
    setPermissions(permissionList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const newFormatDate = (date) => {
    const newDate = date?.split(/[/ ]+/);
    const newFormat = `${newDate[2]}/${newDate[1]}/${newDate[0]} ${newDate[3]}`;
    return newFormat;
  }

  const getDuration = (dates) => {
    if(!(dates?.permitStarDate && dates?.permitEndDate )) return 0;
    const newStartDate = newFormatDate(dates?.permitStarDate);
    const newEndDate = newFormatDate(dates?.permitEndDate);
    const start = moment(newStartDate).toDate();
    const end = moment(newEndDate).toDate()
    const time = moment.duration(moment(end).diff(moment(start)));
    const days = Math.floor(time.asDays());
    const hours = time.hours();
    const minute = time.minutes();
    const textMinute = minute > 0 ? ` - ${minute} minutos` : '';
    const durationInHours = (days * 24) + hours;
    const textHour = durationInHours === 1 ? 'hora' : 'horas';
    const totalDuration = `${durationInHours} ${textHour} ${textMinute}`;
    return totalDuration;


  }

  const getValueByKey = (object, header) => {
    if (header.child === null) {
      if(header.field === 'permissionType'){
        return data?.permissionTypeDescription;
      }
      if(header.field === 'documentType'){
        const document = props.maestras?.tipoDocumnetoIdentificacion?.find(x => x.key === data?.employeeRequesting?.documentType) ?? '';
        return document.value;
      }
      if(header.field === 'permitStarDate'){
        //const initDate = moment(data?.permitStarDate).format("DD/MM/YYYY HH:mm");
        const initDate = data?.permitStarDate.slice(0, 16);
        return initDate;
      }
      if(header.field === 'permitEndDate'){
        //const endDate = moment(data?.permitEndDate).format("DD/MM/YYYY HH:mm");
        const endDate = data?.permitEndDate.slice(0, 16);
        return endDate;
      }
      if(header.field === 'requestDate'){
        //const requestDate = moment(data?.requestDate).format("DD/MM/YYYY HH:mm");
        const requestDate = data?.requestDate.slice(0, 16);
        return requestDate;
      }
      if (header.field) {
        let result = "";
        if (header.field.includes(",")) {
          header.field.split(/\s*,\s*/).forEach(function (myString) {
            result += object[myString] + " ";
          });
          return result;
        }
        if (header.field === "contractType") {
          let clave = object[header.field]?.toUpperCase();
          let valor = contractTypes.find(
            (contrato) => contrato.clave === clave
          );
          return valor ? valor.valor : "";
        }
        if (header.field === "numberDay") {
          const durByHours = getDuration(data);
          return durByHours;
        }
        if (header.field === "status") {
          return object[header.field]
            ?.replaceAll("_", " ")
            .replace("cion", "ción");
        }
        if (header.field === "paid") {
          return object[header.field] ? "Si" : "No";
        }
        return object[header.field];
      }
      return "";
    }
    if (header.title === "REGIONAL") {
      return object[header.field][header.child]?.code ? object[header.field][header.child]?.code : "";
    } else if (header.title === "CARGO SOLICITANTE") {
      return object[header.field][header.child]?.denomination ? object[header.field][header.child]?.denomination : "";
    }
    else {
    return object[header.field] !== null
      ? object[header.field][header.child]
      : "";
    }
  };

  const FlippedOrderExpansionPanelSummary = withStyles({
    root: {
      flexDirection: "row-reverse",
    },
  })(AccordionSummary);
  FlippedOrderExpansionPanelSummary.defaultProps = {
    IconButtonProps: { edge: "start" },
  };

  const handleClickClose = () => {
    setMessage({ ...message, open: false });
  };

  const handleClickApprove = async (comment, paid, data) => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
      isPermissions: false,
      isPermissionApprove:false
    }));
    const newData = {
      id: data?.id,
      observation: comment,
      paid: paid
    };
    const response = await permissionsApprove(newData);
    if (response?.status === 200 || response?.status === 201) {
      setMessage({
        description: `La solicitud de permiso fue aprobada exitosamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      props.getPermissions();
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : `El permiso no ha sido aprobado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const approvePermission = (data) => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro de aprobar esta solicitud de permiso?",
      handleClick: (comm, paid) =>handleClickApprove(comm, paid, data),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: false,
      isPermissions: true,
      isPermissionApprove:true
    }));
  };

  const handleClickCancel = async (comment, data) => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
      isPermissions: false,
      isPermissionApprove:false
    }));
    const newData = {
      id: data?.id,
      observation: comment,
    };
    const response = await permissionsCancel(newData);
    if (response?.status === 200 || response?.status === 201) {
      setMessage({
        description: `Solicitud de permiso Anulada`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      props.getPermissions();
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : `El permiso no ha sido anulado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };

  const handleClickReject = async (comment, data) => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
      isPermissions: false,
      isPermissionApprove:false
    }));
    const newData = {
      id: data?.id,
      observation: comment,
    };
    const response = await permissionsReject(newData);
    if (response?.status === 200 || response?.status === 201) {
      setMessage({
        description: `Solicitud de permiso Rechazada`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "SUCCESS",
        open: true,
      });
      props.getPermissions();
    } else if (
      response?.status > 399 &&
      response?.status !== 401 &&
      response?.status !== 403
    ) {
      setMessage({
        description: response?.data?.detail
          ? response?.data?.detail
          : `El permiso no ha sido rechazado, inténtelo nuevamente`,
        textButtonSubmit: "Aceptar",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    } else {
      setMessage({
        description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
        textButtonSubmit: "ACEPTAR",
        handleClick: () => handleClickClose(),
        oneButtons: true,
        type: "WARNING",
        open: true,
      });
    }
  };


  const anularPermission = (data,text) => {
    setConfirm(() => ({
      open: true,
      question: `¿Está seguro que desea ${text} esta solicitud de permiso?`,
      handleClick: (comm) =>handleClickCancel(comm, data),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: true,
      isPermissions: true,
      isPermissionApprove:false
    }));
  };


  const rejectPermission = (data,text) => {
    setConfirm(() => ({
      open: true,
      question: `¿Está seguro que desea ${text} esta solicitud de permiso?`,
      handleClick: (comm) =>handleClickReject(comm, data),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: true,
      isPermissions: true,
      isPermissionApprove:false
    }));
  };

  const handleClickPreApprove = async (comment, data) => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
      isPermissions: false,
      isPermissionApprove:false
    }));
    const newData = {
      id: data?.id,
      observation: comment,
    };
    const response = await permissionsPreApprove(newData);
     if (response?.status === 200 || response?.status === 201) {
       setMessage({
         description: `La solicitud de permiso fue pre-aprobada exitosamente`,
         textButtonSubmit: "Aceptar",
         handleClick: () => handleClickClose(),
         oneButtons: true,
         type: "SUCCESS",
         open: true,
       });
       props.getPermissions();
     } else if (
       response?.status > 399 &&
       response?.status !== 401 &&
       response?.status !== 403
     ) {
       setMessage({
         description: response?.data?.detail
           ? response?.data?.detail
           : `El permiso no ha sido pre-aprovado, inténtelo nuevamente`,
         textButtonSubmit: "Aceptar",
         handleClick: () => handleClickClose(),
         oneButtons: true,
         type: "WARNING",
         open: true,
       });
     } else {
       setMessage({
         description: `Ocurrió un error procesando la solicitud, inténtelo nuevamente`,
         textButtonSubmit: "ACEPTAR",
         handleClick: () => handleClickClose(),
         oneButtons: true,
         type: "WARNING",
         open: true,
       });
     }
  };

  const closeModal = () => {
    setConfirm((anterior) => ({
      ...anterior,
      open: false,
      isCommentRequired: false,
      isPermissions: false,
      isPermissionApprove:false
    }));
  };

  const preApprovePermission = (data) => {
    setConfirm(() => ({
      open: true,
      question: "¿Está seguro de pre aprobar esta solicitud?",
      handleClick: (comm) =>handleClickPreApprove(comm, data),
      handleClickOut: closeModal,
      buttonOneText: "ACEPTAR",
      isCommentRequired: false,
      isPermissions: true,
      isPermissionApprove:false
    }));
  };

  const renderPreApprovePermission = (data) => {
    var havePermission = permissions?.some(
      (x) => x === permissionsConstans.PERM_PREAPROBAR
    );
    var render = data?.status === "PENDIENTE_POR_APROBACION" && havePermission
    && (data?.employeeApprover?.id === userId || type === APPROVER);
    return render && (<Button
        variant="contained"
        className={classes.buttonAnular}
        onClick={() => preApprovePermission(data)}
      >
        Pre-aprobar
      </Button>)

  }

  const renderApprovePermission = (data) => {
var havePermission = permissions?.some(
  (x) => x === permissionsConstans.PERM_MANAGE_APROBAR
);
    var render = data?.status === "PRE_APROBADA" && havePermission  && type === RHMANAGE;
    return render &&
                    (<Button
                      variant="contained"
                      className={classes.buttonAnular}
                      onClick={() => approvePermission(data)}
                    >
                      Aprobar
                    </Button>)
  }
  const renderDenyPermission = (data) => {
    var havePermission = permissions?.some(
      (x) => x === permissionsConstans.PERM_ANULAR
    );
    var render = data?.status !== "ANULADA" && data?.status !== 'RECHAZADA' && type === NORMALUSER && havePermission;
    return render &&  (<Button
                    variant="contained"
                    className={classes.buttonAnular}
                    onClick={() => anularPermission(data,"anular")}
                  >
                    Anular
                  </Button>)
  }

  const renderRejectPermission = (data) => {
    var renderApprover = data?.status !== "ANULADA" && data?.status !== "RECHAZADA" && type === APPROVER &&
                  permissions?.some(
                    (x) => x === permissionsConstans.PERM_RECHAZAR
                  );

    var renderManage = data?.status !== "ANULADA" && data?.status !== "RECHAZADA" && type === RHMANAGE &&
                  permissions?.some(
                    (x) => x === permissionsConstans.PERM_MANAGE_RECHAZAR
                  );

    return (renderApprover || renderManage) && (<Button
                    variant="contained"
                    className={classes.buttonAnular}
                    onClick={() => rejectPermission(data,"rechazar")}
                  >
                    rechazar
                  </Button>)
  }

  return (
    <div className={classes.root}>
      <Accordion
        style={{
          borderTopLeftRadius: "0px",
          borderTopRightRadius: "0px",
          borderBottomLeftRadius: "0px",
          borderBottomRightRadius: "0px",
        }}
      >
        <FlippedOrderExpansionPanelSummary
          aria-controls="panel1c-content"
          id={id}
          expandIcon={<ExpandMoreIcon />}
        >
          {headers.initialHeaders.map((header) => (
            <div className={classes.column}>
              <Typography className={classes.heading}>
                {header.title}
              </Typography>
              <Typography className={classes.secondaryHeading}>
                {getValueByKey(data, header)}
              </Typography>
            </div>
          ))}
          <div className={classes.columnEvent}>
            <Tooltip title="Ver detalle" arrow placement="top">
              <VisibilityIcon className={classes.iconEvent} />
            </Tooltip>
            &nbsp;&nbsp;
          </div>
        </FlippedOrderExpansionPanelSummary>
        <AccordionDetails className={classes.details}>
          <div className={classes.rootGrid}>
            <Grid container spacing={3}>
              {headers.otherHeaders.map((header) => (
                <Grid item xs={2}>
                  <Typography className={classes.heading}>
                    {header.title}
                  </Typography>
                  <Typography className={classes.secondaryHeading}>
                    {getValueByKey(data, header)}
                  </Typography>
                </Grid>
              ))}

              <Grid container style={{ marginBottom: 10 }}>
                <Grid item xs={6} md={8} lg={8}></Grid>
                <Grid item xs={6} md={4} lg={4} style={{ textAlign: "end", marginBottom: '10px' }}>
                  {renderPreApprovePermission(data)}
                  {renderApprovePermission(data)}
                  {renderDenyPermission(data)}
                  {renderRejectPermission(data)}
                </Grid>
              </Grid>
            </Grid>
          </div>
        </AccordionDetails>
      </Accordion>
      {message?.open && <ModalConfirmBase
        description={message.description}
        textButtonSubmit={message.textButtonSubmit}
        handleClick={message.handleClick}
        handleClickOut={message.handleClickOut}
        oneButtons={message.oneButtons}
        type={message.type}
        open={message.open}
      />}
      {confirm?.open && <ModalConfirmBaseComment
        open={confirm.open}
        description={confirm.question}
        handleClickOut={confirm.handleClickOut}
        handleClick={confirm.handleClick}
        textButtonSubmit={confirm.buttonOneText}
        type="QUESTION"
        isCommentRequired={confirm.isCommentRequired}
        isPermissions={confirm.isPermissions}
        isPermissionApprove={confirm.isPermissionApprove}
      />}
    </div>
  );
};

export default React.memo(DetailedAccordion);
